module.exports = __webpack_public_path__ + "static/media/footer-twitter.68543134.svg";